<template>
  <section>
    <div class="card shadow-sm mb-2">
      <div class="card-body">
        <label>{{ $t('message.booking.contact_step.has_ironing_board') }}</label>
        <div class="d-flex">
          <div class="flex-fill">
            <div class="exp">
              <div class="checkbox">
                <input type="radio"
                        id="hasIroningBoard"
                        name="hasIroningBoard"
                        :value="1"
                        v-model="preCheckoutData.has_ironing_board"
                        v-validate="'required'"/>
                <label for="hasIroningBoard" class="mb-0">
                  <span><!-- This span is needed to create the "checkbox" element --></span>
                  {{ $t('message.confirm.yes') }}
                </label>
              </div>
            </div>
          </div>
          <div class="flex-fill">
            <div class="exp">
              <div class="checkbox">
                <input type="radio"
                        id="hasNoIroningBoard"
                        name="hasIroningBoard"
                        :value="0"
                        v-model="preCheckoutData.has_ironing_board"
                        v-validate="'required'"/>
                <label for="hasNoIroningBoard" class="mb-0">
                  <span><!-- This span is needed to create the "checkbox" element --></span>
                  {{ $t('message.confirm.no') }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="errors.has('hasIroningBoard')" class="text-remark pt-1 text-danger">
      <i class="fas fa-exclamation-triangle"></i> {{ $t('message.required_selection') }}
    </div>
  </section>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    inject: ['$validator'],
    computed: {
      ...mapState('booking', ['preCheckoutData'])
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/booking/components/HasIroningBoard.vue